<template>
    <div class="page">
        <tabs
            class="tabs"
            :items="tabItems" />
        <div class="container">
            <router-view />
        </div>
    </div>
</template>

<script>
import quebecUserModal from '../mixins/QuebecUserModal'
import tabs from '../components/Tabs.vue'

export default {
    components: {
        tabs
    },
    computed: {
        tabItems () {
            return [
                {
                    isActive: this.$route.name === 'account-profile',
                    label: 'Profile',
                    to: { name: 'account-profile' }
                },
                {
                    isActive: this.$route.name === 'account-change-password',
                    label: 'Change Password',
                    to: { name: 'account-change-password' }
                }
            ]
        }
    },
    mixins: [
        quebecUserModal
    ]
}
</script>

<style lang="postcss" scoped>
@import 'theme';

>>> h1 {
    color: #1c74a5;
    font-size: 20px;
    font-weight: 300;
    margin: 0 0 30px;
}

.container {
    background: white;
    border-radius: 5px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    max-width: 500px;
    padding: var(--site-padding);
    width: 100%;

    @media (--mq-medium-min) {
        padding: 40px;
    }
}

.page {
    margin: 0 auto;
    max-width: var(--site-container-width);
    padding: 48px var(--site-padding);
    width: 100%;
}

.tabs {
    margin-bottom: 32px;
}
</style>
